import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { CustomTemplateService } from 'src/proxy';


@Injectable()
export class TemplateTypeStoreService {

  _templateTypes$ = new BehaviorSubject<any[]>(null);

  constructor(
    private customTemplateService: CustomTemplateService
  ) {
  }

  loadTemplateSources() {
    return this.customTemplateService.getSources();
  }

  get templateTypes() {
    return this._templateTypes$.value;
  }

  set templateTypes(data: any[]) {
    this._templateTypes$.next(data);
  }

  get templateTypes$() {
    return this._templateTypes$;
  }
}
